import React from 'react';
import {useTranslation} from "react-i18next";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";

import APIModel from "../../Components/APIModel";
import {LOGO_BY_TYPE} from '../../Components/utils';


const BotUsers = (
    {
        match,
    }
) => {
    const {t, i18n} = useTranslation();

    const BOT_USER_COLUMNS = [
        {
            name: t('audience.bot_users.columns.channel', 'Channel'),
            cell: row => <div>
                <img
                    src={LOGO_BY_TYPE[row.bot.bot_type]}
                    style={{width: '1.3rem'}}
                    className='mr-2'
                />
                {row.bot.name}
            </div>
        },
        {
            name: t('audience.bot_users.columns.name', "Name"),
            selector: "name",
        },
        {
            name: t('audience.bot_users.columns.messenger_user_id', 'User ID in messenger'),
            selector: "messenger_user_id",
        },
        {
            name: t('audience.bot_users.columns.created_at', "Created at"),
            selector: "created_at",
        },
        {
            name: t('audience.bot_users.columns.tags', "Tags"),
            cell: row => <div>
                {
                    get(row, 'store.tags', []).map(
                        (tag, idx) => <div className='my-1' key={idx}>
                            <code className='text-secondary'>
                                {tag.name}
                            </code>
                        </div>
                    )
                }
                {
                    isEmpty(row.store.tags) && '-'
                }
            </div>
        },
    ];

    return <APIModel
        heading={t('audience.bot_users.api_model.heading', 'Subscribers')}
        subheading=''
        icon="pe-7s-user icon-gradient bg-night-fade"
        apiPath='bot/bot_users'
        tableColumns={BOT_USER_COLUMNS}
        tableEmptyMessage={t('audience.bot_users.api_model.message_empty', "No subscribers yet")}
        match={match}
        hasFilters={true}
        deletionDisabled={true}
        creationDisabled={true}
    />;
};

export default BotUsers;
